
//import * as rhelp from './reducer-helper';
import * as types from 'src/types';
import * as model from 'src/data/model';
import * as dal from 'src/data/dal';
import {Track} from '../data/track/track';
import { Action, handleActions } from 'redux-actions';
import * as track from '../data/track/track';
import { CreateSimpleReducer1, CreateSimpleActionReducer1, CreateSimpleReducer0 } from './reducer-helper';
import { AppSection } from '../types/istate';
import { dataTable } from 'src/variables/general';
import { type } from 'os';
let firebaseCreds = require('src/firebase-creds').default;
import * as firebase from 'firebase/app';
import { setupMaster } from 'cluster';
firebase.initializeApp(firebaseCreds);
/*import 'firebase/firebase-auth';
import 'firebase/firebase-firestore';
import 'firebase/firebase-messaging';
import 'firebase/firebase-storage';*/

let reducersList = {};


const startApp = CreateSimpleActionReducer1<any>(
  reducersList,
  "startApp",
  (dispatch: any): any => {
    var func = async (dispatch: any) => {
      try {


        firebase.auth().onAuthStateChanged(function (user: any) {
          ;
          if (user) {
            //@ts-ignore
            firebase
              .auth()
              .currentUser.getIdToken(true)
              .then(async function (idToken: any) {
                let profile = new model.Profile();
                profile.display_name = user['displayName'];
                profile.email = user['email'];
                profile.profile_url = user['photoUrl'];
                profile.token = idToken;
                profile.uid = user['uid'];

                dispatch(setProfile(profile));

              })
              .catch(function (error: any) {
               // alert(error)
                dispatch(clearProfile())
              });
          } else {
            dispatch(clearProfile())
          }
        });

      } catch (e) {
       // e);
        dispatch(clearProfile())
      }
    };
    func(dispatch);
    return dispatch;
  },
  (state: types.IState, payload: any): types.IState => {
    state.dispatch = payload;
    return state;
  }
);

export { startApp };

const setProfile = CreateSimpleReducer1<model.Profile>(
  reducersList,
  "setProfile",
  (state: types.IState, payload: model.Profile): types.IState => {
    let func = async function (state: types.IState) {
      state.lo_ctx.val().PodCast.list(new dal.UpdateCallback<model.PodCast>(
        "podcast",
        state.dispatch,
        podcastLoadedComplete
      )).then((podcasts: Array<model.PodCast>) => {
        state.dispatch(podcastLoadedComplete(podcasts));
      });
      state.lo_ctx.val().Track.list(new dal.UpdateCallback<model.Track>(
        "tracks",
        state.dispatch,
        tracksLoadedComplete
      )).then((tracks: Array<model.Track>) => {
        state.dispatch(tracksLoadedComplete(tracks));
      })
      state.lo_ctx.val().CustomerBalance.list(new dal.UpdateCallback<model.CustomerBalance>(
        "customerBalance",
        state.dispatch,
        cutomerBalanceComplete
      )).then((balances: Array<model.CustomerBalance>) => {
        state.dispatch(cutomerBalanceComplete(balances));
      })

    }

    window['profile'] = payload;
    let profileProvider = new types.FrontEndProfileProvider();
    state.lo_ctx.setCompleted(new dal.Context(profileProvider,firebase));
    Track.SetUserContext({
      email: profileProvider.getProfile().email,
      id: profileProvider.getProfile().uid,
      username: profileProvider.getProfile().email,
    });
    state.lo_PodCasts.setLoading();
    func(state);
    return state;

  }
)



const podcastLoadedComplete = CreateSimpleReducer1<Array<model.PodCast>>(
  reducersList,
  "podcastLoadedComplete",
  (state: types.IState, payload: Array<model.PodCast>): types.IState => {

    state.lo_PodCasts.setCompleted(payload)
    return state;
  }
)
const cutomerBalanceComplete = CreateSimpleReducer1<Array<model.CustomerBalance>>(
  reducersList,
  "cutomerBalanceComplete",
  (state: types.IState, payload: Array<model.CustomerBalance>): types.IState => {
    console.log("Tracks Load Complete")

    let custBal  = new model.CustomerBalance();
    custBal.credits = 0;
    if(payload && payload.length > 0)
    {
      let sorted  = payload.sort((a:model.CustomerBalance,b:model.CustomerBalance)=>{
        let aDate = a.created;
        let bDate = b.created;
        return aDate < bDate ? -1 : 1
       });
      if(payload.length > 1)
      {
         for(var i=1;i<sorted.length;i++)
         {
             console.log('strange multiple customer balances',sorted[i])
             state.lo_ctx.val().CustomerBalance.archive(sorted[i].id);

         }
      }
      custBal = sorted[0];
      state.lo_CustomerBalance.setCompleted(custBal)
    }
    else if(payload.length ==0){
      //probably new account
      let func = async function (state: types.IState) {
        try
        {
          let podcasts = await state.lo_ctx.val().PodCast.list();
          if(podcasts.length == 0)
          {
              /* console.log('create default podcast');
             let podcast = new model.PodCast();
              podcast.title = state.lo_ctx.val().getProfile().display_name+' podcast';
              podcast.feed_status = model.PodCastFeedStatus.ready;
              podcast.descrition = "Your personal podcast for listening to the web.";
              podcast.image_url = state.lo_ctx.val().getProfile().profile_url?state.lo_ctx.val().getProfile().profile_url:"https://firebasestorage.googleapis.com/v0/b/textcast-16d99.appspot.com/o/default_podcast_image.png?alt=media";
    ;         await state.lo_ctx.val().PodCast.save(podcast);*/

          }
         
          let balance = new model.CustomerBalance();
          balance.credits=0;

          balance = await state.lo_ctx.val().CustomerBalance.save(balance);
          balance = await state.lo_ctx.val().CustomerBalance.changePlan(model.PlanCode.trail);

          state.dispatch(cutomerBalanceComplete([balance]))
         /* let tran = new model.Transaction();
          tran.credits = 10;
          tran.transaction_type = model.TransactionType.addCredit;
          tran.amount=0;
          tran.description= "Welcome to Castablog.  Enjoy 10 credits!"
          await state.lo_ctx.val().Transaction.save(tran);*/
          track.Track.Event(track.TrackCategory.webaction,track.TrackEvent.accountCreated);
          try{
            //@ts-ignore
            fbq('track', 'CompleteRegistration', {
              value: 0,
              currency: '0',
            });
          }
          catch(e)
          {
              console.error('could not log facebook tracking event',e);
          }
  

        }
        catch(e)
        {
           track.Track.reportError(e,"Whoops! Error setting up your account",true,state.dispatch);
        }
      }
      func(state)
      
    }
  
    return state;
  }
)
const tracksLoadedComplete = CreateSimpleReducer1<Array<model.Track>>(
  reducersList,
  "tracksLoadedComplete",
  (state: types.IState, payload: Array<model.Track>): types.IState => {
    console.log("Tracks Load Complete")
  
    state.lo_Tracks.setCompleted(payload)
    return state;
  }
)
export const clearProfile = CreateSimpleReducer0(
  reducersList,
  "clearProfile",
  (state: types.IState): types.IState => {
    firebase.auth().signOut();
    localStorage.clear();
    state.lo_ctx.setError("not loggedin");
    if(window.location.pathname != types.ViewState.getDefaultHash(types.AppSection.LogIn))
    {
        
      setTimeout(()=>{
        window.location.href = types.ViewState.getDefaultHash(types.AppSection.LogIn);
    },1)
  }
    return state;
  }
)
const setError = CreateSimpleReducer1<track.ErrorObj>(
  reducersList,
  "setError",
  (state: types.IState, payload: track.ErrorObj): types.IState => {
    ;
    state.errorState.errorArray.push(payload);
    if(payload.showModal)
    {
      state.errorState.showError = true;
    }
    state.errorState.lastError = payload;
    return state;
  }
);
export { setError };
Track.Init(setError);

const closeErrorModal = CreateSimpleReducer0(
  reducersList,
  "closeErrorModal",
  (state: types.IState, payload: any): types.IState => {
    state.errorState.showError = false;
    state.errorState.lastError.showModal = false;
    return state;
  }
);
export { closeErrorModal };

const showErrorModal = CreateSimpleReducer0(
  reducersList,
  "showErrorModal",
  (state: types.IState, payload: any): types.IState => {
    state.errorState.showError = true;
 
    return state;
  }
);
export { showErrorModal };

let Reducer = handleActions(reducersList, types.getDefaultState());

export { Reducer };




// WEBPACK FOOTER //
// ./src/reducers/action-reducer.ts